import React from 'react';

const PlanFeatures = () => {

    return (<>
        <div className="PlanFeatures">
            <h3 className="InvestPopHeads">Plan Features</h3>
            <div className="InvestDetailList">
                <ul>
                    <li>
                        <h4 className="mb-1 ListHead">Tax Benefit</h4>
                        <p className="mb-3 ListPara">Under section 80C and 10 (10D), tax benefits can be claimed for the premiums paid and benefits received.</p>
                    </li>
                  {/*  <li>
                        <h4 className="mb-1 ListHead">Accidental Disability Benefit</h4>
                        <p className="mb-3 ListPara">In the event of disability caused by an accident, the coverage value will be paid to you in addition to the base coverage.</p>
                    </li>
                    <li>
                        <h4 className="mb-1 ListHead">Critical Illness and Disability</h4>
                        <p className="mb-3 ListPara">The rider coverage value will be paid immediately if you are diagnosed with any of the critical illnesses covered.</p>
                    </li>
                    <li>
                        <h4 className="mb-1 ListHead">Cancer Cover</h4>
                        <p className="mb-3 ListPara">If you are diagnosed with cancer, an additional lump-sum amount will be paid to you.</p>
                    </li>
                    <li>
                        <h4 className="mb-1 ListHead">Accidental Death</h4>
                        <p className="mb-3 ListPara">In case of death due to an accident, 100% of the rider cover amount shall be payable along with the base coverage.</p>
                    </li>*/}
                </ul>
            </div>
        </div>
    </>)
}
export default PlanFeatures;